import { Component, Input } from "@angular/core";
import { SurveyStatusEnum } from "../enums/survey-status.enum";

@Component({
	selector: "subsample-status-button",
	template: `
		<a *ngIf="!isLabel" class="btn btn-{{colorClass}} {{class}}">{{surveyStatusEnum[status]}}</a>
		<span *ngIf="isLabel" class="label label-btn label-{{colorClass}} {{class}}" style="margin-top:-3px;">{{surveyStatusEnum[status]}}</span>
` })
export class SubsampleStatusButtonComponent {
	@Input() isLabel: boolean = false;
	@Input() class: string = "";
	@Input() status: SurveyStatusEnum;
	@Input() colorClass?: string = "";
	surveyStatusEnum = SurveyStatusEnum;
}
